<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('adapters.shopify'), $t('text.explain')]"
      ></breadcrumb>
    </div>
    <div class="wrapper table-area">
      <div class="step">
        第一步：首先登陆Shopify账户，然后按照图示中1、2顺序操作；
      </div>
      <img
        src="@/assets/subscribeExplain_shopify/shopify001.jpg"
        height="500"
        width="1000"
        alt
      />
      <div class="step">第二步：滑动页面至页面底部处-左下角（图示中3）点击</div>
      <img
        src="@/assets/subscribeExplain_shopify/shopify002.jpg"
        height="500"
        width="1000"
        alt
      />

      <div class="step">
        第三步：在图示3中点击弹出的页面选择图示中相应字段值，
      </div>
      <div class="step">
        填写URL：https://adapterbkd.jianyingkeji.com/shopify-stores/notify
      </div>
      <img
        src="@/assets/subscribeExplain_shopify/shopify003.jpg"
        height="500"
        width="1000"
        alt
      />
      <div class="step">第四步：在下图查看是否订阅成功</div>
      <img
        src="@/assets/subscribeExplain_shopify/shopify004.png"
        alt
        width="1000"
      />

      <div class="step red">注意：手动订阅在系统不显示订阅信息</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>

<style scoped>
.step {
  font-size: 24px;
  margin-bottom: 20px;
  margin-top: 10px;
}
</style>
